export enum LogType {
	Info    = 'INFO',
	Warning = 'WARN',
	Error   = 'ERROR'
}
